import commemorativeMedalGreetingImageCake from "@/images/metal-ax/ax_cake.png";
import commemorativeMedalGreetingImageCrane from "@/images/metal-ax/ax_crane.png";
import commemorativeMedalGreetingImageEagle from "@/images/metal-ax/ax_eagle.png";
import commemorativeMedalGreetingImageHouse from "@/images/metal-ax/ax_house.png";
import commemorativeMedalGreetingImageThophy from "@/images/metal-ax/ax_trophy.png";

export const engravingDefaultContent = {
  default: { templeName: "", godName: "", gift: "", respect: "" },
  sacredObject: {},
  commemorative_license_plate: {
    commemorativeLicensePlateNumber: "",
    commemorativeLicensePlateImageOption: "nothing",
    commemorativeLicensePlateImageText: "",
    commemorativeLicensePlateImageCustom: "",
    commemorativeLicensePlateReverseText: "",
  },
  commemorative_doorplate: {
    commemorativeDoorplateImageOption: "tainan",
    commemorativeDoorplateImageCustom: "",
    commemorativeDoorplateDistrict: "",
    commemorativeDoorplateRoadName: "",
    commemorativeDoorplateHouseNumber: "",
    commemorativeDoorplateReverseText: "",
  },
  commemorative_medal: {
    commemorativeMedalGreetingsAndName: "",
    commemorativeMedalGreetingMessage: "",
    commemorativeMedalGreetingImageOption: "nothing",
    commemorativeMedalGreetingImageCustom: "",
    commemorativeMedalSenderName: "",
  },
};

export const commemorativeLicensePlateImageOptions = [
  { label: "無", value: "nothing" },
  { label: "純文字", value: "text" },
  { label: "自訂", value: "custom" },
];

export const commemorativeDoorplateImageOptions = [
  { label: "台南市", value: "tainan" },
  { label: "無", value: "nothing" },
  { label: "自訂", value: "custom" },
];

export const commemorativeMedalGreetingImageOptions = [
  { label: "無", value: "nothing", image: "" },
  {
    label: "生日蛋糕",
    value: "cake",
    image: commemorativeMedalGreetingImageCake,
  },
  { label: "鶴", value: "crane", image: commemorativeMedalGreetingImageCrane },
  {
    label: "房屋",
    value: "house",
    image: commemorativeMedalGreetingImageHouse,
  },
  {
    label: "獎盃",
    value: "trophy",
    image: commemorativeMedalGreetingImageThophy,
  },
  {
    label: "老鷹",
    value: "eagle",
    image: commemorativeMedalGreetingImageEagle,
  },
  { label: "自訂", value: "custom", image: "" },
];
